module.exports = __webpack_public_path__ + "img/logo.a58b4a30.png";